import { GraduationCap, Building2, BadgeCheck } from "lucide-react";
import { Reveal, SectionHead } from "@/components/motion";

const EXPOSURE = ["Restaurant", "Breakfast", "Bar", "Events", "Upselling", "POS", "Hotel Standards"];

const MODULES = [
  "Hotel Investment", "Revenue Management", "Hotel Operations", "Strategic Management",
  "Hospitality Information Systems", "Brand Management", "Research Methods",
];

export default function Experience() {
  return (
    <section id="experience" className="border-t border-hairline bg-stone2/50" data-testid="experience-section">
      <div className="mx-auto max-w-[1400px] px-6 py-28 sm:px-10 sm:py-36">
        <SectionHead
          label="Experience & Education"
          title={<>Operational <em className="text-moss">grounding.</em></>}
        />

        <div className="grid grid-cols-1 gap-px border border-hairline bg-hairline lg:grid-cols-12">
          <Reveal className="bg-paper p-8 sm:p-12 lg:col-span-7" data-testid="experience-holiday-inn">
            <div className="flex items-center gap-2 text-moss">
              <Building2 size={16} strokeWidth={1.25} />
              <p className="text-[11px] font-semibold uppercase tracking-[0.22em]">Current — United Kingdom</p>
            </div>
            <h3 className="mt-5 font-serif text-3xl sm:text-4xl font-light text-ink">Holiday Inn Guildford</h3>
            <p className="mt-1 text-sm font-semibold uppercase tracking-[0.14em] text-fog">
              Food & Beverage Team Member — Guildford, United Kingdom
            </p>
            <p className="mt-6 max-w-xl font-serif text-xl font-light italic leading-snug text-smoke">
              “Hotel F&B experience across restaurant, breakfast, bar and events, providing operational context behind the performance metrics I analyse.”
            </p>
            <div className="mt-8 flex flex-wrap gap-2">
              {EXPOSURE.map((e) => (
                <span key={e} className="border border-hairline px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.12em] text-smoke">
                  {e}
                </span>
              ))}
            </div>
            <p className="mt-8 border-t border-hairline pt-6 text-sm leading-relaxed text-fog">
              Earlier front-of-house hospitality experience in India — approximately two years across India and the UK combined.
            </p>
          </Reveal>

          <div className="flex flex-col gap-px bg-hairline lg:col-span-5">
            <Reveal delay={0.08} className="flex-1 bg-paper p-8 sm:p-12" data-testid="education-surrey">
              <div className="flex items-center gap-2 text-moss">
                <GraduationCap size={16} strokeWidth={1.25} />
                <p className="text-[11px] font-semibold uppercase tracking-[0.22em]">Education</p>
              </div>
              <h3 className="mt-5 font-serif text-3xl font-light text-ink">University of Surrey</h3>
              <p className="mt-1 text-sm font-semibold uppercase tracking-[0.14em] text-fog">
                MSc Strategic Hotel Management — 2026
              </p>
              <p className="mt-5 text-sm leading-relaxed text-smoke">
                Project-based postgraduate training — a live feasibility study, a total-revenue strategy, an F&B performance investigation and a brand portfolio strategy.
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {MODULES.map((m) => (
                  <span key={m} className="border border-hairline px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.12em] text-smoke">
                    {m}
                  </span>
                ))}
              </div>
            </Reveal>

            <Reveal delay={0.16} className="bg-moss p-8 sm:p-12" data-testid="certification-hsmai">
              <div className="flex items-center gap-2 text-champagne">
                <BadgeCheck size={16} strokeWidth={1.25} />
                <p className="text-[11px] font-semibold uppercase tracking-[0.22em]">Certification</p>
              </div>
              <h3 className="mt-5 font-serif text-3xl font-light text-paper">HSMAI Revenue Management Certificate</h3>
              <p className="mt-4 text-sm leading-relaxed text-paper/60">
                Strengthens my working understanding of hotel revenue strategy — pricing, demand and commercial performance.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
